import { authFetch } from "../utils/authFetch"
import { format } from "date-fns" // Importa 'format' de date-fns
import { API_BASE_URL } from "../config"

const getSucursal = () => {
  return localStorage.getItem("idsucursal")
}

// La función ahora acepta un objeto con el rango de fechas y opcionalmente idTipoTarifa
const fetchData = async ({ fechaInicio, fechaFin, idTipoTarifa }) => {
  try {
    const idSucu = getSucursal()

    // Valida que las fechas existan antes de formatear
    if (!fechaInicio || !fechaFin) {
      throw new Error("Las fechas de inicio y fin son requeridas.")
    }

    // Formatea las fechas al formato YYYY-MM-DD que el backend espera
    const fechaInicioStr = format(fechaInicio, "yyyy-MM-dd")
    const fechaFinStr = format(fechaFin, "yyyy-MM-dd")

    // Construye la nueva URL con el endpoint correcto y los parámetros de fecha
    let url = `${API_BASE_URL}/tickets/estado-pagados/1/sucursal/${idSucu}?fechaInicio=${fechaInicioStr}&fechaFin=${fechaFinStr}`

    // Si se envía idTipoTarifa y no es "Todas", usa el endpoint filtrado
    if (idTipoTarifa && idTipoTarifa !== "Todas" && idTipoTarifa !== -1) {
      url = `${API_BASE_URL}/tickets/estado-pagados/1/sucursal/${idSucu}/filtro-tarifa?fechaInicio=${fechaInicioStr}&fechaFin=${fechaFinStr}&idTipoTarifa=${idTipoTarifa}`
    }
    const response = await authFetch(url, {
      method: "GET",
    })

    if (!response.ok) {
      throw new Error("Error al obtener datos del servidor")
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error("Error en fetchData:", error)
    throw error // Re-lanza el error para manejarlo en el componente
  }
}

export { fetchData }